// hooks/useEventSlotCreate.js
import { useState, useCallback } from "react";
import { managementService } from "../services/managementService.js";
import { SLOT_STATUSES } from "../utils";

export function useEventSlotCreate(onSuccess) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const createEventSlot = useCallback(
    async (formData, createPendingRecurrenceFn = null) => {
      setSubmitting(true);
      setError(null);

      const eventPayload = {
        name: formData.name,
        event_type: formData.event_type,
      };

      const slotPayload = {
        slot_date: formData.slot_date,
        start_time: formData.is_all_day ? null : formData.start_time,
        end_time: formData.is_all_day ? null : formData.end_time,
        is_all_day: formData.is_all_day,
        slot_status: formData.slot_status,
      };

      try {
        // 1. Créer l'event
        const createdEvent = await managementService.createEvent(eventPayload);

        // 2. Créer le slot
        const createdSlot = await managementService.createSlot({
          ...slotPayload,
          event_id: createdEvent.id,
        });

        // 3. Créer la récurrence pending si la fonction est fournie
        let createdRecurrence = null;
        if (
          createPendingRecurrenceFn &&
          typeof createPendingRecurrenceFn === "function"
        ) {
          try {
            createdRecurrence = await createPendingRecurrenceFn(
              createdEvent.id,
              slotPayload, // Passer slotPayload
            );
          } catch (recurrenceError) {
            console.error(
              "Erreur création récurrence (non bloquant):",
              recurrenceError,
            );
          }
        }

        // 4. Ajouter instructeurs et participants en parallèle
        const promises = [];

        if (formData.instructor_ids.length > 0) {
          promises.push(
            managementService.assignInstructors(
              createdSlot.id,
              formData.instructor_ids,
            ),
          );
        }

        if (formData.participants.length > 0) {
          promises.push(
            managementService.addParticipants(
              createdSlot.id,
              formData.participants,
            ),
          );
        }

        await Promise.all(promises);

        if (onSuccess) {
          onSuccess({
            event: createdEvent,
            slot: createdSlot,
            recurrence: createdRecurrence,
          });
        }

        return {
          event: createdEvent,
          slot: createdSlot,
          recurrence: createdRecurrence,
        };
      } catch (err) {
        const errorMessage = err.message || "Erreur lors de la création";
        setError(errorMessage);
        console.error("Erreur création event/slot:", err);
        throw err;
      } finally {
        setSubmitting(false);
      }
    },
    [onSuccess],
  );

  return {
    createEventSlot,
    submitting,
    error,
  };
}
